import React from 'react';
import PropTypes from 'prop-types';

export default class ExitWarning extends React.Component {
    static propTypes = {
        message: PropTypes.string
    };

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleBeforeunload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeunload);
    }

    handleBeforeunload = event => {
        const { message } = this.props;

        event.preventDefault();
        event.returnValue = message;
    };

    render() {
        return null;
    }
}
